import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import ServiceHero from './components/ServiceHero';
import ServiceOverview from './components/ServiceOverview';
import SocialMediaSection from './components/SocialMediaSection';
import WebDevelopmentSection from './components/WebDevelopmentSection';
import AppDevelopmentSection from './components/AppDevelopmentSection';
import ServiceComparison from './components/ServiceComparison';
import ConsultationBooking from './components/ConsultationBooking';

const ServicesUniversePage = () => {
  return (
    <>
      <Helmet>
        <title>Services Universe - Comprehensive Digital Solutions | Singh Creations</title>
        <meta 
          name="description" 
          content="Discover Singh Creations' complete digital transformation services: Social Media Marketing, Web Development, and App Development. Interactive demos, client success stories, and personalized consultations." 
        />
        <meta name="keywords" content="digital services, social media marketing, web development, app development, digital transformation, Singh Creations" />
        <meta property="og:title" content="Services Universe - Comprehensive Digital Solutions | Singh Creations" />
        <meta property="og:description" content="Complete digital transformation services with interactive demos and proven results." />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="/services" />
      </Helmet>
      <div className="min-h-screen bg-background">
        <Header />
        
        <main className="pt-16">
          {/* Hero Section */}
          <ServiceHero />
          
          {/* Service Overview */}
          <ServiceOverview />
          
          {/* Social Media Marketing Section */}
          <SocialMediaSection />
          
          {/* Web Development Section */}
          <WebDevelopmentSection />
          
          {/* App Development Section */}
          <AppDevelopmentSection />
          
          {/* Service Comparison Tool */}
          <ServiceComparison />
          
          {/* Consultation Booking */}
          <ConsultationBooking />
        </main>

        {/* Footer */}
        <footer className="bg-secondary text-secondary-foreground py-12">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="grid md:grid-cols-4 gap-8">
              <div>
                <div className="flex items-center space-x-3 mb-6">
                  <div className="w-10 h-10 bg-gradient-to-br from-accent to-accent/80 rounded-lg flex items-center justify-center">
                    <svg viewBox="0 0 24 24" className="w-6 h-6 text-white" fill="currentColor">
                      <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold">Singh Creations</h3>
                    <p className="text-xs text-secondary-foreground/80">Digital Atelier</p>
                  </div>
                </div>
                <p className="text-secondary-foreground/80 text-sm leading-relaxed">
                  Crafting digital experiences that transform businesses and create meaningful connections between brands and their audiences.
                </p>
              </div>
              
              <div>
                <h4 className="font-semibold mb-4">Services</h4>
                <ul className="space-y-2 text-sm text-secondary-foreground/80">
                  <li>Social Media Marketing</li>
                  <li>Web Development</li>
                  <li>App Development</li>
                  <li>Digital Strategy</li>
                </ul>
              </div>
              
              <div>
                <h4 className="font-semibold mb-4">Company</h4>
                <ul className="space-y-2 text-sm text-secondary-foreground/80">
                  <li>About Us</li>
                  <li>Our Process</li>
                  <li>Case Studies</li>
                  <li>Contact</li>
                </ul>
              </div>
              
              <div>
                <h4 className="font-semibold mb-4">Connect</h4>
                <ul className="space-y-2 text-sm text-secondary-foreground/80">
                  <li>singhcreations23@gmail.com</li>
                  <li>+91-7982843491</li>
                  {/* <li>LinkedIn</li> */}
                  {/* <li>Twitter</li> */}
                </ul>
              </div>
            </div>
            
            <div className="border-t border-secondary-foreground/20 mt-8 pt-8 text-center">
              <p className="text-sm text-secondary-foreground/60">
                © {new Date()?.getFullYear()} Singh Creations. All rights reserved.
              </p>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default ServicesUniversePage;